import _ from 'lodash';
import { TEMPORARY_COMPANY_PREFIX, SUBSCRIPTION_PLAN, REAL_ESTATE_INDUSTY_ID } from '../config';
import {
	getSubscriptionsAndAddons,
	convertPlanIdIntoSubscription,
	hasDesktopSubscription,
	hasCancelledDesktopSubscription,
	hasRealEstateSubscription,
	hasCancelledReSubscription,
	hasCloudSubscription,
	hasCancelledCloudSubscription,
	getPendingPerpetualPlans
} from './subscription';

import { getIsReUpgradePopupFlag } from './storage';

/**
 * Ideally this shouldn't be needed: the reducers should expose this information in a convenient fashion
 * But since with the current design we need to access this nested piece of data from various components, the best option for
 * now is to have an helper to do it in a centralized place.
 *
 * @param {} state of the application
 * @returns {boolean} is the user administrator of the currently selected company?
 */
export const isAdmin = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].userIsAdmin;
};

export const isGuest = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].userIsGuest;
};

export const isTempCompany = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].displayName.indexOf(TEMPORARY_COMPANY_PREFIX) == 0;
};

export const getMarketingTags = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].marketingTags;
};

export const showNewRealEstateUI = (company, isDesktopTrial, isReAccessNoIndustry) => {
	if (!company) {
		return false;
	}

	let { hasTrial, isActive, industryId } = company;

	if (isReAccessNoIndustry || getIsReUpgradePopupFlag()) {
		return true;
	}

	if (industryId === REAL_ESTATE_INDUSTY_ID ||
		hasRealEstateSubscription(company) ||
		hasCancelledReSubscription(company)) {

		const { perpetualAddons } = getSubscriptionsAndAddons(company);

		let hasPendingReSubscription = false;
		let hasPendingDesktopSubscription = false;
		const pendingSubscription = _.get(this.state, 'pendingSubscription');

		if (!_.isEmpty(pendingSubscription)) {
			const { plan: savedCheckoutPlan } = convertPlanIdIntoSubscription(pendingSubscription);

			if ([SUBSCRIPTION_PLAN.INDIVIDUAL_AGENT, SUBSCRIPTION_PLAN.BROKERAGES].includes(savedCheckoutPlan)) {
				hasPendingReSubscription = true;
			}

			if ([SUBSCRIPTION_PLAN.PHOTO, SUBSCRIPTION_PLAN.WEB, SUBSCRIPTION_PLAN.DESIGNER].includes(savedCheckoutPlan)) {
				hasPendingDesktopSubscription = true;
			}				
		}

		let { subscription: cancelledSubscription } = getSubscriptionsAndAddons(company, true);

		const pendingPerpetualPlans = getPendingPerpetualPlans(company);

		if (company.hasUnlimitedTeamSubscription) {
			return false;
		} else if (
			// Keep old UI active for users with existing subscriptions on old packages
			hasCloudSubscription(company) ||

			// show old UI to "desktop users" in RE industry
			!_.isEmpty(perpetualAddons) ||
			!_.isEmpty(pendingPerpetualPlans) ||
			hasPendingDesktopSubscription ||
			(isDesktopTrial && !cancelledSubscription) ||
			hasDesktopSubscription(company) ||
			hasCancelledDesktopSubscription(company)
		) {
			return false;

		} else if (hasTrial ||
			!isActive ||
			hasPendingReSubscription || 
			hasRealEstateSubscription(company) ||
			hasCancelledReSubscription(company) ||
			// Once they fully churn, show the new RE UI to Scale/Essential users:
			hasCancelledCloudSubscription(company)
		) {
			// show new RE UI to trials/freee users in RE industry and active subscribers of new RE plans,
			return true;
		}

	} else {
		return false;
	}
};

export const isNewRealEstateUiUsed = (store) => {
	const state = store.getState();
	const companiesRawData = _.get(state, 'companies.rawDataById');
	const selectedCompanyRawData = companiesRawData[state.companies.selectedId];
	return showNewRealEstateUI(selectedCompanyRawData, state.app.isDesktopTrial, state.app.isReAccessNoIndustry);
};



// WEBPACK FOOTER //
// ./src/utils/state.js